import { Factory } from "@/data/dao/Factory";
import { VoucherDao } from "@/data/dao/service/VoucherDao";
import type { IVoucher } from "@/data/model/Voucher";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { VoucherCodeGenerator } from "@/portal/forms/VoucherCodeGenerator";
import { VoucherForm } from "@/portal/forms/VoucherForm";

export class VoucherController extends BaseTabbedController<IVoucher> {
    private voucherForm: VoucherForm;
    private permalinkGenerator?: VoucherCodeGenerator;

    constructor(element: JQuery) {
        super(element, Factory.getInstance(VoucherDao));

        this.voucherForm = new VoucherForm(this.formContentByTabName("voucher-edit"));
        this.registerModelForm(this.voucherForm);

        this.onActivateTab = (newTab) => {
            if (newTab === "voucher-share") this.showVoucherCodeGenerator();
        };
    }

    protected onModelLoaded(m?: IVoucher) {
        if (m === undefined) {
            return false;
        }

        this.enableTabs(["voucher-share"]);
        this.voucherForm.setData(m);
    }

    private showVoucherCodeGenerator() {
        if (this.permalinkGenerator === undefined)
            this.permalinkGenerator = new VoucherCodeGenerator(
                this.formContentByTabName("voucher-share").find(".voucher-code-generator")
            );

        this.permalinkGenerator.loadForVoucher(this.entityId!);
    }
}
